/**
 * Floating video bubble — load policy.
 *
 * History: the bubble is a thumbnail-sized decorative element (~130x175px) that
 * pointed at the full-resolution product video. On the Rocket Bookshelf PDP that
 * file is ~38MB at 1080p/7.2Mbps; on another PDP it was 36MB. It originally had
 * `autoplay`, which overrides `preload` and pulled the whole file during page
 * load on mobile.
 *
 * An earlier fix removed `autoplay` and started playback from here once the page
 * had loaded and the main thread was idle. That avoided competing with first
 * render, but it still downloaded multiple megabytes on every mobile page view
 * for a decorative loop - measured at 2.7MB and still climbing mid-download.
 *
 * The bubble now renders its first frame as a still image (`preload="metadata"`
 * on the <video>, which fetches only the header plus one keyframe) and the full
 * file is fetched only when the visitor actually taps the bubble to open the
 * lightbox. Nothing here starts playback by itself, so this script can never
 * trigger a video download; it only stops playback when the tab is hidden so a
 * user-initiated video does not keep decoding in the background.
 */
(function () {
  var videos = document.querySelectorAll('[data-bubble-video]');
  if (!videos.length) return;

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) return;
    videos.forEach(function (video) {
      if (!video.paused) video.pause();
    });
  });
})();
